import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=1089ffce&scoped=true&lang=pug&"
import script from "./Table.js?vue&type=script&lang=js&"
export * from "./Table.js?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=1089ffce&prod&scoped=true&lang=css&"
import style1 from "./Table.vue?vue&type=style&index=1&id=1089ffce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089ffce",
  null
  
)

export default component.exports